export type InboxQuickMessageSortable = {
  id: string;
  name: string;
  sort_order?: number;
  is_favorite?: boolean;
};

/** Favoritos primeiro, depois sort_order e nome. */
export function sortInboxQuickMessages<T extends InboxQuickMessageSortable>(items: T[]): T[] {
  return [...items].sort((a, b) => {
    const favA = a.is_favorite ? 1 : 0;
    const favB = b.is_favorite ? 1 : 0;
    if (favA !== favB) return favB - favA;
    const orderA = Number(a.sort_order ?? 0);
    const orderB = Number(b.sort_order ?? 0);
    if (orderA !== orderB) return orderA - orderB;
    return a.name.localeCompare(b.name, 'pt-BR');
  });
}
